import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Dialog,
  DialogContent,
  withMobileDialog,
  withStyles,
  IconButton,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { toggleDialog } from 'actions/view'
import A2P10DLC from './A2P10DLC'
import { createSelector } from 'reselect'

function parseQueryString(queryString) {
  const params = {}
  const pairs = (
    queryString[0] === '?' ? queryString.substr(1) : queryString
  ).split('&')
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return params
}

class YourComponent extends React.Component {
  componentDidMount() {
    console.log('A2P10DLC Dialog mounted')
    console.log('this.props.loadStatus: ', this.props.loadStatus)
    console.log(
      'this.props.brandregistrationerrors: ',
      this.props.brandregistrationerrors,
    )
    this.updateDialogStateFromQueryString()
  }

  componentDidUpdate(prevProps) {
    console.log('A2P10DLC Dialog componentDidUpdate')
    if (prevProps.location.search !== this.props.location.search) {
      this.updateDialogStateFromQueryString()
    }
  }

  updateDialogStateFromQueryString = () => {
    const queryParams = parseQueryString(this.props.location.search)
    const dialogShouldBeOpen = queryParams.dialog === 'A2P10DLC'

    let options = {}
    try {
      options = queryParams.dialogOptions
        ? JSON.parse(decodeURIComponent(queryParams.dialogOptions))
        : {}
    } catch (e) {
      console.warn('Failed to parse dialogOptions:', e)
    }

    if (dialogShouldBeOpen !== Boolean(this.props.open)) {
      this.props.toggleDialog({
        open: dialogShouldBeOpen,
        dialog: 'A2P10DLC',
        options,
      })
    }
  }

  handleClose = () => {
    const { history, location, toggleDialog } = this.props

    toggleDialog({
      open: false,
      dialog: 'A2P10DLC',
    })

    const queryParams = new URLSearchParams(location.search)
    queryParams.delete('dialog')
    queryParams.delete('dialogOptions') // Remove options when closing

    history.push({
      pathname: location.pathname,
      search: queryParams.toString(),
    })
  }

  render() {
    const { fullScreen, open, classes } = this.props

    return (
      <Dialog
        fullWidth
        maxWidth="xl"
        fullScreen={fullScreen}
        open={Boolean(open)}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{ classes: { rounded: classes.rounded } }}
      >
        <IconButton
          onClick={this.handleClose}
          style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}
        >
          <Close />
        </IconButton>
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
          <A2P10DLC handleClose={this.handleClose} {...this.props} />
        </DialogContent>
      </Dialog>
    )
  }
}

const getA2P10DLCData = state => state.data.a2p10dlc
const getLoadStatus = state => state.loadStatus?.a2p10dlc

export const getBrandRegistrationErrors = createSelector(
  [getA2P10DLCData, getLoadStatus],
  (a2p10dlcData, loadStatus) => {
    if (loadStatus !== 'SUCCESS') return {}

    const errors = {}
    const data = Object.values(a2p10dlcData || {})[0] || {}
    const { brands = {}, customerProfiles = {}, trustProducts = {} } = data

    // Check brand registration errors
    Object.entries(brands).forEach(([brandSID, brand]) => {
      if (brand.brandregistrationerrors?.length) {
        errors[brandSID] = brand.brandregistrationerrors
      }
    })

    // Check customer profile errors (step_1)
    Object.entries(customerProfiles).forEach(([profileSID, profile]) => {
      if (profile.failure_reason) {
        // Split failure reasons by semicolon
        const failureReasons = profile.failure_reason
          .split(';')
          .filter(reason => reason.trim())
          .map(reason => ({
            customerProfileError: {
              description: reason.trim(),
            },
          }))

        if (failureReasons.length > 0) {
          // Add a final error object with the general solutions guidance
          failureReasons.push({
            customerProfileError: {
              description: 'Additional help resources:',
              solutions:
                'Please review and update your information to ensure all details are accurate and verifiable.',
            },
          })
          errors[profileSID] = failureReasons
          errors.step = 1
        }
      }
    })

    // Check trust products errors (step_2)
    Object.entries(trustProducts).forEach(([productSID, product]) => {
      if (product.failure_reason) {
        const failureReasons = product.failure_reason
          .split(';')
          .filter(reason => reason.trim())
          .map(reason => ({
            trustProductError: {
              description: reason.trim(),
            },
          }))

        if (failureReasons.length > 0) {
          failureReasons.push({
            trustProductError: {
              description: 'Additional help resources:',
              solutions:
                'Please review and update your information to ensure all details are accurate and verifiable.',
            },
          })
          errors[productSID] = failureReasons
          // Only set step to 2 if there are no customer profile errors
          if (!errors.step) {
            errors.step = 2
          }
        }
      }
    })

    return Object.keys(errors).length > 0 ? errors : null
  },
)

const mapStateToProps = state => {
  // const brandsObj = Object.values(state.data.a2p10dlc || {})?.[0]?.brands
  // const brandSIDs = Object.keys(brandsObj || {})

  // const brandregistrationerrors = brandSIDs.reduce((acc, brandSID) => {
  //   const brand = brandsObj[brandSID]
  //   if (brand.brandregistrationerrors?.length) {
  //     acc[brandSID] = brand.brandregistrationerrors
  //   }
  //   return acc
  // }, {})

  return {
    // dialogOpen: state.view.dialogs?.A2P10DLC?.open,
    // directive: state.view.dialogs?.A2P10DLC?.directive,
    ...(state.view.dialogs?.A2P10DLC || {}),
    // brandregistrationerrors,
    brandregistrationerrors: getBrandRegistrationErrors(state),
    loadStatus: state.loadStatus?.a2p10dlc,
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ toggleDialog }, dispatch)

export default withRouter(
  withMobileDialog()(
    withStyles(theme => ({
      rounded: {
        borderRadius: 28,
        overflowY: 'hidden',
        // height: '100%',
        [theme.breakpoints.down('sm')]: {
          borderRadius: 0,
          overflowY: 'auto',
        },
      },
      dialogContentRoot: {
        padding: 0,
        '&:first-child': {
          paddingTop: 0,
        },
      },
    }))(connect(mapStateToProps, mapDispatchToProps)(YourComponent)),
  ),
)
